module.exports = __webpack_public_path__ + "img/plats.a68a87e3.png";